export default "__VITE_ASSET__VAPV6FME__"